import React from 'react';
import { Button, Icon, Text, Tooltip, theme } from 'components';
import styled from 'styled-components';
import { featureEnabled } from 'utils';
import { mlsStaffMenuOptionsMap } from 'components/SideMenu/MenuSection/types';
import { useHistory } from 'react-router-dom';
import { AuthContext } from 'contexts';
import SearchBar from './SearchBar';
import { useMLSStaffContext } from './MLSStaffContext';
import AddUserPopover from './MLSStaffUsersPage/AddUserPopover';

const MLSStaffRightHeader: React.FC = () => {
  const {
    selectedMenu,
    total,
    initialTotal,
    csvLink,
    loading,
    selectedLockboxes,
    selectedUsers,
    setModalVisible,
    addUserPopoverVisible,
    setAddUserPopoverVisible,
    setManualCoopModalVisible,
  } = useMLSStaffContext();

  const { auth } = React.useContext(AuthContext);

  const features = auth?.org.features;

  const history = useHistory();
  const handleActivityClickBtn = () => {
    if (selectedMenu === 'lockboxes') {
      const query = selectedLockboxes.reduce(
        (acc, lockbox) => `${acc}${lockbox},`,
        '',
      );
      history.push(`/mls/lockboxesActivities?lockboxIds=${query}`);
    } else if (selectedMenu === 'users') {
      const query = selectedUsers.reduce((acc, user) => `${acc}${user},`, '');
      history.push(`/mls/lockboxesActivities?userIds=${query}`);
    }
  };

  const handleQuickAssignActivityClickBtn = () => {
    history.push(`/mls/quick-assignment-activity`);
  };

  const addUserElement = featureEnabled('supraManualCoopFeature') ? (
    <AddUserPopover
      visible={addUserPopoverVisible}
      setVisible={setAddUserPopoverVisible}
      setModalVisible={setModalVisible}
      setManualCoopModalVisible={setManualCoopModalVisible}
    />
  ) : (
    <Button
      onClick={() => {
        setModalVisible(true);
      }}
    >
      <Icon type="plus" offset={[0, 2]} />
      Add User
    </Button>
  );

  return (
    <StyledContainer>
      {features.includes('MLS_STAFF_ADD_USERS') &&
        !loading &&
        selectedMenu === 'users' &&
        addUserElement}
      {!loading && selectedMenu !== 'brokerages' ? (
        <Button
          disabled={!selectedLockboxes.length && !selectedUsers.length}
          onClick={handleActivityClickBtn}
        >
          View Activities
        </Button>
      ) : null}

      {!loading &&
        selectedMenu === 'lockboxes' &&
        featureEnabled('quickLockboxAssignmentFeature') &&
        features.includes('MLS_STAFF_QUICK_LOCKBOX_ASSIGNMENT') && (
          <>
            <Button onClick={handleQuickAssignActivityClickBtn}>
              View Quick Assignment Activities
            </Button>
          </>
        )}

      {!loading && (
        <StyledText data-count={total} data-total={initialTotal}>
          {total} of {initialTotal} {mlsStaffMenuOptionsMap[selectedMenu]}
        </StyledText>
      )}

      <SearchBar type={selectedMenu} />

      <Tooltip
        title="Can only export up to 50 pages from the current page."
        placement="topRight"
        data-cy="mls-staff-tooltip"
      >
        <StyledButton
          data-cy="export-button"
          href={csvLink}
          rel="noopener noreferrer"
          target="_blank"
          disabled={loading}
        >
          <StyledIcon type="antdFileTextOutlined" width={12} color="black" />{' '}
          Export .csv
        </StyledButton>
      </Tooltip>
    </StyledContainer>
  );
};

export default MLSStaffRightHeader;

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding-bottom: 5px;
`;

const StyledText = styled(Text)`
  color: ${theme.textColorSecondary};
  font-size: 14px;
`;

const StyledIcon = styled(Icon)`
  margin-top: 1px;
`;

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 3px !important;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
`;
